import { NestedFilter } from '@@partner:types:graphql'
import { makeBetweenFilter, makeFilter } from './crud/filters'
import { AssemblingShiftsFiltersType } from '@components/assembling/shifts/AssemblingShiftsFilter'

export function prepareAssemblingWorkShiftFilter (filters: AssemblingShiftsFiltersType): NestedFilter {
  // Фильтр по дате планируемого начала (plannedStartAt -> ts_starting)
  const dateFilter = makeBetweenFilter('ts_starting', {
    from: filters.dateRange?.[0].getTime(),
    to: filters.dateRange?.[1].getTime()
  })

  const assemblerFilter = makeFilter('assemblerId', 'contains', filters.assemblerIds)

  return {
    and: [
      dateFilter,
      assemblerFilter
    ]
  }
}